/* ----------------------------------------------------------------------------
automatically sets Mac or Windows download links based on user agent
---------------------------------------------------------------------------- */

export default class DownloadLink extends HTMLElement {
  setLink() {
    const userAgent = window.navigator.userAgent;
    const isMac = userAgent.indexOf('Mac') !== -1;
    const isWin = userAgent.indexOf('Windows') !== -1;

    for (const link of this.linkElements) {
      const platform = link.getAttribute('data-platform');
      if ((isMac && platform !== 'mac') || (isWin && platform !== 'windows')) {
        link.remove();
      } else {
        link.classList.remove('hidden');
      }
    }
  }

  connectedCallback() {
    this.linkElements = this.querySelectorAll('a');
    this.setLink();
  }
}

window.customElements.define('download-link', DownloadLink);
